export class FieldGuideStruct {

    public nameVariableGrievanceNotification: string;
    public fieldValue: string;
    public complementFieldValue: string;

    public idFieldGrievanceNotification: number;
}